<template>
  <div id="app">
    <notifications group="notification" position="top center" />
    <Transition name="fast-fade">
      <LocalSettingsModal v-if="$store.state.activeModal === 'local'" />
    </Transition>
    <Transition name="fast-fade">
      <OnlineSettingsModal v-if="$store.state.activeModal === 'online'" />
    </Transition>
    <UserBar />
    <router-view />
  </div>
</template>

<script>
import UserBar from '@/components/UserBar'
import LocalSettingsModal from '@/components/modals/LocalSettingsModal'
import OnlineSettingsModal from '@/components/modals/OnlineSettingsModal'
import { nanoid } from 'nanoid'

export default {
  name: 'App',

  components: { UserBar, LocalSettingsModal, OnlineSettingsModal },

  created() {
    // save id & username in localstoreage if it doesn't exist
    const username = window.localStorage.getItem('username')
    const id = window.localStorage.getItem('id')

    if (!username) {
      window.localStorage.setItem('username', 'Anonymous')
    }

    if (!id) {
      window.localStorage.setItem('id', nanoid())
    }
  }
}
</script>

<style lang="scss">
@import './scss/styles.scss';

html,
body {
  height: 100%;
  position: absolute;
  width: 100%;
}

#app {
  background-attachment: fixed;
  background-image: url(./assets/birmingham-museums-trust.jpg);
  background-position: 50%;
  background-size: cover;
  font-family: 'Oswald', Helvetica, Arial, sans-serif;
  min-height: 100vh;
  overflow: hidden;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue